export class DateTime {
  day: number;
  month: number;
  year: number;
  hour: number;
  minute: number;

  constructor(day: number, month: number, year: number, hour: number, minute: number) {
    this.day = day;
    this.month = month;
    this.year = year;
    this.hour = hour;
    this.minute = minute;
  }
}
